/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ({

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Give - Stripe Gateway Payment Request JS
 */

var stripe = Stripe(give_stripe_vars.publishable_key);

if (give_stripe_vars.stripe_account_id) {
	stripe = Stripe(give_stripe_vars.publishable_key, {
		stripeAccount: give_stripe_vars.stripe_account_id
	});
}

document.addEventListener('DOMContentLoaded', function () {
	// Get all the donation forms on a single page.
	var formWraps = document.querySelectorAll('.give-form-wrap');
	var prButton = [];
	var paymentRequest = [];
	var isPRButtonExists = [];
	var defaultGateway = '';
	var preferredLocale = give_stripe_vars.preferred_locale;

	// Loop through each donation form.
	Array.prototype.forEach.call(formWraps, function (formWrap) {
		var form_element = formWrap.querySelector('.give-form');

		// Bailout, if `form_element` is null.
		if (null === form_element) {
			return;
		}

		var formID = form_element.querySelector('input[name=give-form-id]').value,
		    idPrefix = form_element.getAttribute('data-id'),
		    modalButton = formWrap.querySelector('.give-btn-modal'),
		    gridModalLauncher = document.querySelector('#give-card-' + formID),
		    hasModalButton = null !== modalButton,
		    hasGridModalLauncher = null !== gridModalLauncher,
		    elements = stripe.elements({
			locale: preferredLocale
		});

		if (null !== form_element.querySelector('.give-gateway-option-selected .give-gateway')) {
			defaultGateway = form_element.querySelector('.give-gateway-option-selected .give-gateway').value;
		}

		// Set default value for payment request button exists flag.
		isPRButtonExists[idPrefix] = false;

		// Set default gateway value on changing gateway.
		Array.prototype.forEach.call(form_element.querySelectorAll('.give-gateway'), function (gateway_element) {
			gateway_element.addEventListener('change', function (e) {
				if (gateway_element.checked) {
					defaultGateway = gateway_element.value;
				}
			});
		});

		// Prepare tabs and payment request button on gateway load.
		jQuery(document).on('give_gateway_loaded', function (event, xhr, settings) {
			if (defaultGateway === 'stripe_google_pay' || defaultGateway === 'stripe_apple_pay') {
				preparePaymentRequestButton(idPrefix, elements);
			}
		});

		// Remount payment button when open popup after first time (form grid mode, modal mode, button mode).
		if (hasModalButton) {
			modalButton.addEventListener('click', reMountPaymentRequestButton);
		}

		if (hasGridModalLauncher) {
			gridModalLauncher.addEventListener('click', reMountPaymentRequestButton);
		}

		// Remount payment button when donor redirect to form page after error.
		if (Give.fn.getParameterByName('form-id') === form_element.querySelector('input[name=give-form-id]').value && ['stripe_google_pay', 'stripe_apple_pay'].includes(Give.fn.getParameterByName('payment-mode')) && (hasModalButton || hasGridModalLauncher)) {
			var intitalPaymentRequestButtonsetup = window.setInterval(function () {
				if (jQuery.magnificPopup.instance.isOpen) {
					var $formFromPopup = document.getElementsByClassName('mfp-wrap')[0].getElementsByClassName('give-form');

					if ($formFromPopup.length) {
						preparePaymentRequestButton(idPrefix, elements);
						window.clearTimeout(intitalPaymentRequestButtonsetup);
					}
				}
			}, 500);
		} else {
			// Load custom events when default gateway is stripe on load.
			if ('stripe_google_pay' === defaultGateway || 'stripe_apple_pay' === defaultGateway) {
				preparePaymentRequestButton(idPrefix, elements);
			}
		}

		/**
   * ReMount Payment request button
   *
   * @since 2.2.3
   */
		function reMountPaymentRequestButton() {
			if (defaultGateway === 'stripe_google_pay' || defaultGateway === 'stripe_apple_pay') {
				if ('undefined' !== typeof prButton[idPrefix]) {
					prButton[idPrefix].removeListener('click');
					prButton[idPrefix].unmount('#give-stripe-payment-request-button-' + idPrefix);
				}

				preparePaymentRequestButton(idPrefix, elements);
			}
		}

		/**
   * Prepare Payment Request Button.
   *
   * @param {string} idPrefix ID Prefix.
   * @param {object} elements Stripe Elements Object.
   *
   * @since 1.6
   */
		function preparePaymentRequestButton(idPrefix, elements) {
			var _this = this;

			var formName = form_element.querySelector('input[name="give-form-title"]');
			var donationAmount = Give.fn.unFormatCurrency(form_element.querySelector('.give-final-total-amount').dataset.total, form_element.dataset.decimal_separator);

			if ('undefined' === typeof paymentRequest[idPrefix]) {
				// Setup the payment request with Stripe.
				paymentRequest[idPrefix] = stripe.paymentRequest({
					country: give_stripe_vars.base_country,
					currency: form_element.getAttribute('data-currency_code').toLowerCase(),
					total: {
						label: formName.value,
						amount: Math.round(donationAmount * 100)
					},
					requestShipping: false,
					requestPayerName: true
				});

				// Add event.
				paymentRequest[idPrefix].on('paymentmethod', function () {
					var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev) {
						var billingDetails, cardCountryElement, cardAddressElement, cardAddress2Element, cardCityElement, cardZipElement, cardStateElement;
						return regeneratorRuntime.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										billingDetails = ev.paymentMethod.billing_details;

										form_element.querySelector('input[name="give_stripe_payment_method"]').value = ev.paymentMethod.id;

										cardCountryElement = document.createElement('input');

										cardCountryElement.setAttribute('type', 'hidden');
										cardCountryElement.setAttribute('name', 'billing_country');
										form_element.appendChild(cardCountryElement).value = billingDetails.address.country;

										cardAddressElement = document.createElement('input');

										cardAddressElement.setAttribute('type', 'hidden');
										cardAddressElement.setAttribute('name', 'card_address');
										form_element.appendChild(cardAddressElement).value = billingDetails.address.line1;

										cardAddress2Element = document.createElement('input');

										cardAddress2Element.setAttribute('type', 'hidden');
										cardAddress2Element.setAttribute('name', 'card_address_2');
										form_element.appendChild(cardAddress2Element).value = billingDetails.address.line2;

										cardCityElement = document.createElement('input');

										cardCityElement.setAttribute('type', 'hidden');
										cardCityElement.setAttribute('name', 'card_city');
										form_element.appendChild(cardCityElement).value = billingDetails.address.city;

										cardZipElement = document.createElement('input');

										cardZipElement.setAttribute('type', 'hidden');
										cardZipElement.setAttribute('name', 'card_zip');
										form_element.appendChild(cardZipElement).value = billingDetails.address.postal_code;

										cardStateElement = document.createElement('input');

										cardStateElement.setAttribute('type', 'hidden');
										cardStateElement.setAttribute('name', 'card_state');
										form_element.appendChild(cardStateElement).value = billingDetails.address.state.toUpperCase();

										// Submit the form and complete.
										form_element.submit();
										ev.complete('success');

									case 28:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, _this);
					}));

					return function (_x) {
						return _ref.apply(this, arguments);
					};
				}());
			}

			// Check if the button exists, if it doesn't create it.
			if (false === isPRButtonExists[idPrefix]) {
				prButton[idPrefix] = elements.create('paymentRequestButton', {
					paymentRequest: paymentRequest[idPrefix],
					style: {
						paymentRequestButton: {
							type: 'donate',
							theme: give_stripe_vars.payment_request_button_style,
							height: '64px'
						}
					}
				});

				isPRButtonExists[idPrefix] = true;
			}

			// Check the availability of the Payment Request API first.
			paymentRequest[idPrefix].canMakePayment().then(function (result) {
				var paymentRequestButton = document.getElementById('give-stripe-payment-request-button-' + idPrefix);

				if (paymentRequestButton) {
					if (result) {
						prButton[idPrefix].mount('#give-stripe-payment-request-button-' + idPrefix);
						isPRButtonExists[idPrefix] = true;
					}
					paymentRequestButton.style.display = 'block';
				}
			});

			prButton[idPrefix].on('click', function (evt) {
				var verifyPayment = new XMLHttpRequest();
				var formData = new FormData(form_element);
				var errorElement = form_element.querySelector('#give-stripe-payment-errors-' + idPrefix);
				donationAmount = Give.fn.unFormatCurrency(form_element.querySelector('.give-final-total-amount').dataset.total, form_element.dataset.decimal_separator);

				formData.append('action', 'give_process_donation');
				formData.append('give_ajax', true);

				paymentRequest[idPrefix].update({
					currency: form_element.getAttribute('data-currency_code').toLowerCase(),
					total: {
						label: formName.value,
						amount: Math.round(donationAmount * 100)
					}
				});

				// Do something on Ajax on state change.
				verifyPayment.onreadystatechange = function () {
					if (4 === this.readyState && 200 === this.status && 'success' !== this.responseText) {
						evt.preventDefault();
						errorElement.innerHTML = this.response;
					} else {
						errorElement.innerHTML = '';
					}
				};
				verifyPayment.open('POST', give_global_vars.ajaxurl, false);
				verifyPayment.send(formData);
			});
		}
	});
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/give-stripe-payment-request.js